import {StyleSheet} from 'react-native';

import {cloudLight} from '/theme/color/on.color';

export const styles = StyleSheet.create({
  base: {
    marginTop: 20,
  },
  listItem: {},
  listItemWithBorder: {
    borderTopWidth: 1,
    borderTopColor: cloudLight,
  },
});
